module.exports = __webpack_public_path__ + "img/icon_yscj.24fe4db4.png";